import { render, staticRenderFns } from "./GeneralInformationTab.vue?vue&type=template&id=76226a9f&"
import script from "./GeneralInformationTab.vue?vue&type=script&lang=js&"
export * from "./GeneralInformationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports